var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',[_vm._v("Envío de códigos promocionales")]),_vm._v(" "),_c('p',[_vm._v("El equipo de "+_vm._s(_vm.host)+" le agradece su confianza. En señal de agradecimiento, enviaremos periódicamente códigos promocionales a los jugadores habituales. ¡Disfruta el juego!")])])}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// c:/Jenkins/workspace/play-at-home-test-frontend-deploy-sites/src/onlinecasino/OnlineCasino.Web.Public/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!c:/Jenkins/workspace/play-at-home-test-frontend-deploy-sites/src/onlinecasino/OnlineCasino.Web.Public/node_modules/vue-loader/lib??vue-loader-options!./skins/bulmasite/components/pages/sitepages/bonus-rules/bonus-rules-mailing/es.vue?vue&type=template&id=6ca7b898
// module id = Cz0p
// module chunks = 0